import React from "react";
import EditableTable from "./_EditableTable";

/**
 * Fit-to-Standard / Process Design tab.
 * L1–L4 process hierarchy with fit/gap classification + WRICEF tracking.
 */
export default function FitToStandard() {
  return (
    <>
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 section-eyebrow">Fit-to-Standard / Process Design</div>
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-zinc-900 mt-1">Process Fit</h2>
        <p className="text-sm text-zinc-500 mt-1 max-w-3xl">L1–L4 process hierarchy · SAP Best Practices coverage · WRICEF (Workflow, Reports, Interfaces, Conversions, Enhancements, Forms).</p>
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Process hierarchy · fit / gap classification</div>
        <EditableTable
          sectionKey="fitToStandard"
          listKey="processes"
          testidPrefix="fts"
          labelSingular="process"
          columns={[
            { key: "l1",  label: "L1 domain", width: "140px" },
            { key: "l2",  label: "L2 process", width: "160px" },
            { key: "l3",  label: "L3 activity" },
            { key: "l4",  label: "L4 task" },
            { key: "fit", label: "Fit", type: "select", options: ["Fit", "Workaround", "Custom", "Deferred"], width: "120px" },
            { key: "maturity", label: "Maturity", type: "select", options: ["Ad-hoc", "Defined", "Managed", "Optimized"], width: "110px" },
            { key: "owner", label: "Owner", width: "120px" },
          ]}
          emptyRow={() => ({ l1: "", l2: "", l3: "", l4: "", fit: "Fit", maturity: "Defined", owner: "" })}
        />
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">WRICEF register</div>
        <EditableTable
          sectionKey="fitToStandard"
          listKey="wricef"
          testidPrefix="wr"
          labelSingular="WRICEF item"
          columns={[
            { key: "ref", label: "Ref", width: "80px" },
            { key: "type", label: "Type", type: "select", options: ["Workflow", "Report", "Interface", "Conversion", "Enhancement", "Form"], width: "120px" },
            { key: "name", label: "Name" },
            { key: "process", label: "Linked process" },
            { key: "complexity", label: "Complexity", type: "select", options: ["Low", "Medium", "High"], width: "110px" },
            { key: "status", label: "Status", type: "select", options: ["Backlog", "In Design", "In Build", "Unit Tested", "Ready for Cutover", "Live"], width: "150px" },
            { key: "owner", label: "Owner", width: "120px" },
          ]}
          emptyRow={() => ({ ref: "", type: "Enhancement", name: "", process: "", complexity: "Medium", status: "Backlog", owner: "" })}
        />
      </div>
    </>
  );
}
